module.exports = __webpack_public_path__ + "media/images/icons/flags/VC-526fb61113202eb8f68a65b494388168.svg";